// extracted by mini-css-extract-plugin
export default {"pop_up":"styles_pop_up__fL6PD","report":"styles_report__gls+k"};